import styled from 'styled-components';
import { styledComponentProps } from '../../types/theme';

export const HeadingOne = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.xl}px;
  font-weight: normal;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.darkForestGreen};
  font-family: inherit;
  font-weight: bolder;
  line-height: 1;
  :first-letter {
    text-transform: uppercase;
  }
`;

export const HeadingTwo = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.lg}px;
  font-weight: normal;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.darkForestGreen};
  font-family: inherit;
  font-weight: bold;
  :first-letter{
    text-transform: uppercase;
  }
`;

export const Body = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.md}px;
  font-weight: normal;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.barIlanTextGreen};
  font-family: inherit;
  :first-letter{
    text-transform: uppercase;
  }
`;

export const BodyBold = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.md}px;
  font-weight: bold;
  color: ${({ theme }: styledComponentProps): string =>{
    return theme.colors.ui.darkForestGreen
  }};
  font-family: inherit;
  :first-letter{
    text-transform: uppercase;
  }
`;

export const BodyBoldTwo = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.md}px;
  font-weight: bold;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.barIlanTextLightGreen};
  font-family: inherit;
  :first-letter{
    text-transform: uppercase;
  }
`;

export const BodyBoldSm = styled.p`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.sm - 1}px;
  font-weight: bold;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.darkForestGreen};
  font-family: inherit;
  :first-letter{
    text-transform: uppercase;
  }
`;

export const BodyBoldXs = styled.p<any>`
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.xs}px;
  font-weight: 500;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.barIlanTextLightGreen};
  font-family: inherit;
  margin: 0 ${({ theme, margin }: styledComponentProps): number =>
      margin === 'none'?0:2}px;
  :first-letter{
    text-transform: uppercase;
  }

`;
